
import { useState } from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button } from 'components/Button/Button'
import { PriceCard } from 'pages/settings/pages/subscriptionOptions/components/PriceCard'


type CustomAmountProps = {
  defaultAmount: number
  minAmount: number
  maxAmount: number
  onSubmit: (amount: number) => Promise<any>
  onPayoutSettings: () => void
  onClose: () => void
}

const CustomAmount = ({
  defaultAmount,
  minAmount,
  maxAmount,
  onSubmit,
  onClose,
  onPayoutSettings
}:CustomAmountProps) => {
  const [isAmountValid, setIsAmountValid] = useState<boolean>(true)
  const { t } = useTranslation()
const [errorMessage, setErrorMessage] = useState('')
const [showPayoutSettings, setShowPayoutSettings] = useState(false)
const [funds, setFunds] = useState<number | string>(defaultAmount || minAmount)
  const checkIsAmountValid = (amount: number) => {
    const isValid = amount >= minAmount && amount <= maxAmount
    setIsAmountValid(isValid)
    return isValid
  }
  
const handleSubmit = async () => {
  setErrorMessage('')
  setShowPayoutSettings(false)

  const amount = Number(funds)

  if (!checkIsAmountValid(amount)) return

  const result = await onSubmit(amount)

  const backendError = result?.data?.message

  if (backendError?.status === 'error') {
    setErrorMessage(backendError.message)
    setShowPayoutSettings(backendError.code === 'missing_payout_details')
  }
}
  return (
    <div>
      <Separator />
      <PriceCard
        label={t('settings:addFundsPriceCardLabel')}
        price={funds}
        updatePrice={(val: string | number) => {
          if (val === '') {
            setFunds('')
            setIsAmountValid(true)
            return
          }

          const amount = Number(val)

          setFunds(amount)
          checkIsAmountValid(amount)
        }}
        validateFn={checkIsAmountValid}
        isValid={isAmountValid}
        parseValue={false}
      />

      {!isAmountValid && (
        <small className='subsOptions__fields__validation invalidPrice'>
          {t('You must enter a valid amount!')}
        </small>
      )}

      <MinMaxPrice>
        <div>
          Min <strong>${minAmount}</strong> Max <strong>${maxAmount}</strong>
        </div>
      </MinMaxPrice>
      {errorMessage && (
        <PayoutError>{t(errorMessage)}</PayoutError>
      )}
      <FundsFooter>
        <Button
          text='Close'
          color='grey'
          font='mont-14-normal'
          width='10'
          height='3'
          clickFn={onClose}
        />

        {showPayoutSettings ? (
          <Button
            text='Payout Settings'
            color='black'
            font='mont-14-normal'
            width='16'
            height='4'
            clickFn={onPayoutSettings}
          />
        ) : (
          <Button
            text='Submit'
            color='blue'
            font='mont-14-normal'
            width='13'
            height='4'
            clickFn={handleSubmit}
            disabled={!isAmountValid}
          />
        )}
      </FundsFooter>
    </div>
  )
}

// Styled Components
const Separator = styled.div`
  border-top: 1px solid #d9d9d9;
  margin-bottom: 2.5rem;
`
const PayoutError = styled.div`
  padding: 1.2rem 1.4rem;
  margin-bottom: 1.6rem;
  border-radius: 1.5rem;
  background: #fff1f1;
  color: #d92d20;
  font-size: 1.3rem;
  line-height: 1.8rem;
  margin-top:1.5rem;
`
const MinMaxPrice = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 1.2rem;

  strong {
    font-weight: 600;
  }
`

const FundsFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2.5rem;
`

export default CustomAmount

